<script lang="ts">
  import '../app.css';

  import type { Snippet } from 'svelte';
  import type { LayoutServerResponse } from '@glimja/storefront/pages/root-layout/server';
  import { RootLayout } from '@glimja/storefront/pages';

  const { data, children }: { data: LayoutServerResponse; children?: Snippet; } = $props();
</script>

<RootLayout data={data} colorVariant={'primary.contrast'}>
  {@render children?.()}
</RootLayout>
